<template>
  <!-- "Rezervă ▾": one button, the type is picked from the menu before the modal
       opens (it can still be switched inside the modal). While picking days on
       the grid, the same spot shows confirm / cancel instead. -->
  <div class="tt-reserve" v-on-clickaway="close">
    <template v-if="!selectMode">
      <div class="tt-reserve__group">
        <button type="button" class="btn btn-warning btn-sm tt-reserve__toggle"
                :aria-expanded="open ? 'true' : 'false'" aria-haspopup="true"
                @click.stop.prevent="toggle()">
          <hero-icon name="plus-circle"></hero-icon>
          {{ texts.reserve || 'Rezervă' }}
          <hero-icon name="chevron-down" class="tt-reserve__caret"></hero-icon>
        </button>
        <button type="button" class="btn btn-warning btn-sm tt-btn-outline"
                @click.stop.prevent="selectDays()">
          {{ texts.vacation_select_days || 'Selectează zile' }}
        </button>
      </div>

      <ul class="tt-menu tt-reserve__menu tt-surface shadow" v-if="open" role="menu">
        <li class="tt-menu__label">{{ texts.reserve_type || 'Tip rezervare' }}</li>
        <li class="tt-menu__item" role="none">
          <a role="menuitem" @click.stop.prevent="pick('vacation')">
            <hero-icon name="sun"></hero-icon>
            <strong>{{ texts.vacation_type_label || 'Concediu' }}</strong>
          </a>
        </li>
        <li class="tt-menu__item" role="none">
          <a role="menuitem" @click.stop.prevent="pick('reservation')">
            <hero-icon name="lock-closed"></hero-icon>
            <strong>{{ texts.reservation_block || 'Blochează' }}</strong>
          </a>
        </li>
        <li class="tt-menu__divider" role="separator"></li>
        <li class="tt-menu__item" role="none">
          <a role="menuitem" @click.stop.prevent="selectDays()">
            <hero-icon name="calendar-days"></hero-icon>
            {{ texts.reservation_select_days_hint || 'Selectează zile pe calendar…' }}
          </a>
        </li>
      </ul>
    </template>

    <template v-else>
      <button type="button" class="btn btn-success btn-sm"
              :disabled="!selectedCount"
              @click.stop.prevent="$emit('confirm')">
        <hero-icon name="check"></hero-icon>
        {{ texts.reservation_confirm || 'Rezervă' }} ({{ selectedCount }})
      </button>
      <button type="button" class="btn btn-sm tt-btn-ghost"
              @click.stop.prevent="$emit('cancel')">
        {{ texts.cancel || 'Renunță' }}
      </button>
    </template>
  </div>
</template>

<script>
import HeroIcon from "./HeroIcon.vue";

export default {
  name: "ReserveMenu",

  components: { "hero-icon": HeroIcon },

  props: {
    selectMode: { type: Boolean, default: false },
    selectedCount: { type: Number, default: 0 },
    texts: { type: Object, default: () => ({}) },
  },

  data() {
    return { open: false };
  },

  directives: {
    // Minimal click-away: close when a click lands outside the component.
    "on-clickaway": {
      bind(el, binding) {
        el.__reserveClickaway = (e) => {
          if (!el.contains(e.target)) binding.value();
        };
        document.addEventListener("click", el.__reserveClickaway);
      },
      unbind(el) {
        document.removeEventListener("click", el.__reserveClickaway);
        delete el.__reserveClickaway;
      },
    },
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },
    close() {
      this.open = false;
    },
    pick(type) {
      this.close();
      this.$emit("reserve", type);
    },
    selectDays() {
      this.close();
      this.$emit("select-days");
    },
  },
};
</script>
